// Policy version info - should match backend POLICY_VERSIONS
export const POLICY_VERSIONS = {
  terms: '1.0',
  privacy: '1.0',
  payments: '1.0',
  cancellation: '1.0',
  host_obligations: '1.0',
  guest_responsibilities: '1.0',
  platform_disclaimer: '1.0'
};

export const POLICY_LAST_UPDATED = '2025-01-17';

// Helper to create policy acceptance objects
export const createPolicyAcceptance = (policyType, context) => ({
  policy_type: policyType,
  policy_version: POLICY_VERSIONS[policyType],
  context
});

// Required policies by context
export const SIGNUP_POLICIES = ['terms', 'privacy'];
export const CHECKOUT_POLICIES = ['terms', 'cancellation', 'payments'];
export const HOST_ONBOARDING_POLICIES = ['host_obligations', 'payments', 'platform_disclaimer'];
